/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Fix 1: nested flyout submenus (e.g. "Gereedschap per beroep") can overflow below the
 * visible viewport when they contain many items. This constrains only the deepest
 * ("leaf") nested dropdowns to a max height and makes them scrollable instead of
 * getting cut off. Intermediate levels that still contain a further submenu are left
 * with normal overflow so their child flyout (3rd level, e.g. "Accu gereedschap")
 * can still escape and render correctly instead of being clipped.
 *
 * Fix 2: polished menu styling — darker, calmer link text, a soft light-blue hover
 * highlight with a subtle accent bar (instead of the harsher default green) and a
 * light transition so hovering feels smooth rather than abrupt. IMPORTANT: no
 * overflow:hidden is used anywhere here, since that would clip flyout submenus that
 * need to render outside their parent's box (this broke it once already — don't
 * reintroduce overflow:hidden on .nav-dropdown or .nav-dropdown__item).
 */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.nav-dropdown .nav-dropdown:not(:has(.nav-dropdown)) { max-height: 75vh; overflow-y: auto; overscroll-behavior: contain; }' +
    '.nav-dropdown__item { position: relative; }' +
    '.nav-dropdown__link { color: #1f2a3c !important; font-weight: 400 !important; border-radius: 6px; margin: 0 4px; padding-left: 12px !important; transition: background-color .18s ease, color .18s ease, padding-left .18s ease; }' +
    '.nav-dropdown__item > .nav-dropdown__link:hover, .nav-dropdown__item:hover > .nav-dropdown__link { background-color: #eaf3fc !important; color: #14568f !important; padding-left: 18px !important; }' +
    '.nav-dropdown__item:hover { background-color: transparent; }' +
    '.nav-dropdown__item > .nav-dropdown__link:hover::before, .nav-dropdown__item:hover > .nav-dropdown__link::before { content: \'\'; position: absolute; left: 0; top: 8px; bottom: 8px; width: 3px; border-radius: 2px; background: #2f7fd6; }' +
    '.nav-dropdown { border-radius: 8px; box-shadow: 0 8px 24px rgba(20,30,50,0.12); }';
  document.head.appendChild(style);
})();

/**
 * MZS: merkkaarten met foto in het menu "Audio & elektronica".
 * Zet de vier merktegels (VolkanoX, Volkano, Caliber, Amplify) om naar kaarten met
 * een foto, de merknaam en het aantal artikelen — in de stijl van de categoriekaarten
 * (wegwijzer). Foto en aantal komen live uit de collectie (/collections/<handle>.json),
 * dus een andere foto kies je gewoon bij de collectie in de Shopify-admin.
 */
(function () {
  var HOOFD = '/collections/audio-elektronica';

  var css =
    '.mzs-ref-mega.mzs-cardmenu .mzs-ref-mega__links{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:16px!important}' +
    '.mzs-cardmenu .mzs-ref-mega__group{margin:0!important;padding:0!important;border:0!important;background:none!important}' +
    '.mzs-cardmenu a.mzs-ref-mega__parent.mzs-card{display:flex!important;flex-direction:column;align-items:stretch;padding:0!important;background:#fff!important;border:1px solid #d9e3f0!important;border-radius:14px!important;box-shadow:0 3px 10px rgba(0,27,68,.06);overflow:hidden;text-decoration:none!important;transition:transform .18s ease,box-shadow .18s ease}' +
    '.mzs-cardmenu a.mzs-ref-mega__parent.mzs-card:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(0,27,68,.12)}' +
    '.mzs-cardmenu a.mzs-ref-mega__parent.mzs-card::after,.mzs-cardmenu a.mzs-ref-mega__parent.mzs-card::before{display:none!important}' +
    '.mzs-card__img{display:flex;align-items:center;justify-content:center;height:180px;background:#fff;padding:14px;box-sizing:border-box}' +
    '.mzs-card__img img{width:100%;height:100%;object-fit:contain;display:block}' +
    '.mzs-card__body{padding:12px 14px 14px;border-top:1px solid #eef2f7}' +
    '.mzs-card__title{display:block;font-size:16px;font-weight:700;color:#102a6b;line-height:1.3}' +
    '.mzs-card__count{display:block;font-size:13px;color:#6b7a90;margin-top:3px}' +
    '@media(max-width:1100px){.mzs-ref-mega.mzs-cardmenu .mzs-ref-mega__links{grid-template-columns:repeat(2,minmax(0,1fr))!important}}';

  function maakKaarten() {
    var heads = document.querySelectorAll('.mzs-ref-mega__head a');
    for (var i = 0; i < heads.length; i++) {
      var href = (heads[i].getAttribute('href') || '').split('?')[0];
      if (href !== HOOFD) continue;
      var mega = heads[i].closest('.mzs-ref-mega');
      if (!mega || mega.classList.contains('mzs-cardmenu')) continue;
      mega.classList.add('mzs-cardmenu');
      var links = mega.querySelectorAll('a.mzs-ref-mega__parent');
      for (var j = 0; j < links.length; j++) bouwKaart(links[j]);
    }
  }

  function bouwKaart(a) {
    var naam = a.textContent.trim();
    var handle = (a.getAttribute('href') || '').split('?')[0].split('/collections/')[1];
    if (!handle) return;
    a.classList.add('mzs-card');
    a.innerHTML =
      '<span class="mzs-card__img"></span>' +
      '<span class="mzs-card__body"><span class="mzs-card__title"></span><span class="mzs-card__count">&nbsp;</span></span>';
    a.querySelector('.mzs-card__title').textContent = naam;
    fetch('/collections/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.collection;
        if (!c) return;
        if (c.image && c.image.src) {
          var img = document.createElement('img');
          img.src = c.image.src + (c.image.src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          img.alt = naam;
          img.loading = 'lazy';
          a.querySelector('.mzs-card__img').appendChild(img);
        }
        if (typeof c.products_count === 'number') {
          a.querySelector('.mzs-card__count').textContent = c.products_count + ' artikelen';
        }
      })
      .catch(function () {});
  }

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maakKaarten);
  else maakKaarten();
})();

/**
 * MZS: hoofdcategorieën in het categoriemenu op alfabet (A bovenaan), op desktop,
 * mobiel en in het uitklapmenu. "Nieuw binnen" en "Slijpservice" blijven onderaan.
 * Alleen de weergave; de volgorde in het menu in de Shopify-admin blijft zoals hij is.
 */
(function () {
  var ONDERAAN = ['nieuw binnen', 'slijpservice'];
  function tekst(li) {
    var el = li.querySelector('a, button, span');
    return el ? el.textContent.replace(/[›>]/g, '').replace(/\s+/g, ' ').trim() : '';
  }
  function sorteer() {
    var lijsten = document.querySelectorAll('ul, ol');
    for (var i = 0; i < lijsten.length; i++) {
      var lijst = lijsten[i], cats = [], onder = [], heeftAuto = false, heeftAudio = false;
      for (var j = 0; j < lijst.children.length; j++) {
        var li = lijst.children[j];
        if (li.tagName !== 'LI') continue;
        var t = tekst(li), k = t.toLowerCase();
        if (!t) continue;
        if (k.indexOf('auto gereedschap') === 0) heeftAuto = true;
        if (k.indexOf('audio & elektronica') === 0) heeftAudio = true;
        if (ONDERAAN.some(function (o) { return k.indexOf(o) === 0; })) onder.push(li); else cats.push({ li: li, t: t });
      }
      if (!heeftAuto || !heeftAudio) continue;
      cats.sort(function (a, b) { return a.t.localeCompare(b.t, 'nl', { sensitivity: 'base' }); });
      var anker = onder.length ? onder[0] : null;
      cats.forEach(function (c) { lijst.insertBefore(c.li, anker); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sorteer);
  else sorteer();
})();
